export default function debounce(cb: any, wait = 20) {
  let h: ReturnType<typeof setTimeout> | null = null;
  let callable = (...args: any) => {
    h && clearTimeout(h);
    h = setTimeout(() => cb(...args), wait);
  };
  return callable;
}
